import getCookie from './getCookie.js';
import { getInstance } from '../../msalSingleton.js';

export default async function refreshMicrosoftIdentity() {
  const msalClient = getInstance();
  if (msalClient == null) return;

  const loginHint = getCookie('msal-login-hint');
  if (loginHint == null) return;

  try {
    const request = {
      redirectUri: window.location.hostname.endsWith('.localhost')
        ? `http://localhost:8080/entra-id-redirect.html?server-port=3000&domain-name=${window.location.hostname.replace(
            '.localhost',
            ''
          )}`
        : `${window.location.origin}/entra-id-redirect.html`,
      loginHint
    };

    const response = await msalClient.ssoSilent(request);
    const { idToken } = response;
    return idToken;
  } catch (err) {
    console.error(err);

    throw Object.assign(new Error(`Error while refreshing msal identity : ${err.message}`), {
      status: 401
    });
  }
}
